import { styled } from '@mui/material'
import Grid from '@mui/material/Grid2'

export const HeaderWrapper = styled(Grid)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    borderBottom: '1px solid #F4F4F6',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
}))
